module.exports = __webpack_public_path__ + "img/IMG_2493_L_Foamcore.c1490f77.jpg";